import { GameConstants } from "./GameConstants";
import { GameVars } from "./GameVars";
import { BoardManager } from "./scenes/board-scene/BoardManager";
import { AudioManager } from "./AudioManager";

export class GameManager {

    public static init(): void {  

        GameVars.languages = GameVars.currentScene.cache.json.get("languages");

        GameVars.intitialised = true;

        GameManager.setGameScaleX();

        const domains: string [] = [];
       
        if (GameVars.areValidDomains(domains)) {
            GameManager.readGameData();
        } 
    }

    public static setGameScaleX(): void {

        if (GameVars.currentScene.sys.game.device.os.desktop) {

            GameVars.scaleX = 1;

        } else {

            let w = window.innerWidth;
            let h = window.innerHeight;

            GameVars.currentScene.game.scale.displaySize = GameVars.currentScene.game.scale.parentSize;
            GameVars.currentScene.game.scale.refresh();  

            const aspectRatio = w / h;
            GameVars.scaleX = (GameConstants.GAME_WIDTH / GameConstants.GAME_HEIGHT) / aspectRatio;
        }
    }

    public static readGameData(): void {

        GameManager.getGameStorageData(
            GameConstants.SAVED_GAME_DATA_KEY,
            function (gameData: string): void {

                if (gameData) {
                    GameVars.gameData = JSON.parse(gameData);
                } else {
                    GameVars.gameData = {
                        muted: false,
                        language: GameConstants.LANGUAGE_EN
                    };
                }

                GameManager.startGame();
            }
        );
    }

    public static setCurrentScene(scene: Phaser.Scene): void {

        GameVars.currentScene = scene;
    }

    public static onGameAssetsLoaded(): void {

        AudioManager.init();
        
        GameManager.enterSplashScene();
        // GameManager.enterBoardScene();
    }

    public static enterSplashScene(): void {

        GameVars.currentScene.scene.start("SplashScene");
    }

    public static enterBoardScene(): void {

        GameVars.currentScene.scene.start("BoardScene");
    }

    public static reset(): void {

        GameVars.currentScene.scene.start("BoardScene");
    }

    public static play(): void {

        BoardManager.startGame();
    }

    public static replay(): void {

        GameManager.enterBoardScene();
    }

    public static writeGameData(): void {

        GameManager.setGameStorageData(
            GameConstants.SAVED_GAME_DATA_KEY,
            GameVars.gameData,
            function (): void {
                GameManager.log("game data successfully saved");
            }
        );
    }

    public static log(text: string, error?: Error): void {

        if (!GameConstants.VERBOSE) {
            return;
        }

        if (error) {
            console.error(text + ":", error);
        } else {
            console.log(text);
        }
    }

    private static startGame(): void {

        GameVars.currentScene.scene.start("PreloadScene");
    }

    private static getGameStorageData(key: string, successCb: Function): void {

        const gameDataStr = localStorage.getItem(key);
        successCb(gameDataStr);
    }

    private static setGameStorageData(key: string, value: any, successCb: Function): void {

        localStorage.setItem(key, JSON.stringify(value));
        successCb();
    }
}
